import React from 'react'
import { useTranslation } from 'react-i18next'

const TableHeaderProjectStringToRemove = () => {
  const { t } = useTranslation('ProjectsPage')

  return (
    <tr>
      <th>{t('TableHeaderProjectStringToRemove.key')}</th>
      <th>{t('TableHeaderProjectStringToRemove.path')}</th>
      <th>{t('TableHeaderProjectStringToRemove.locale')}</th>
      <th>{t('TableHeaderProjectStringToRemove.value')}</th>
      <th>{t('TableHeaderProjectStringToRemove.action')}</th>
    </tr>
  )
}

export default TableHeaderProjectStringToRemove
